import { ref } from 'vue';

// 角色排序映射：roleId -> 排序值，数值越小排在前面
const ROLE_SORT_MAP: Record<string, number> = {
  // 管理员
  '1000009013': 1,
  '6012': 1,
  // 本部质量人员
  '6003': 2,
  '1000014394': 2,
  // 地区质量人员
  '1000014395': 3,
  '6004': 3,
  // 核查接口人
  '5897': 4,
  '1000008999': 4,
  // 大众评审员
  '1000014520': 5,
  '10345': 5,
  // 运单查询-敏感查单
  '18043': 6,
  '1000038928': 6,
  // 运单查询-普通查单
  '18044': 7,
  '1000038929': 7,
}

const roles = ref<any[]>([]);
const currentRole = ref<string>(sessionStorage.getItem('gw-bdus-rid') || '');

export const useRolesState = () => {
  const sortRoles = (roleList: any[]) => {
    return roleList.sort((a, b) => {
      // 获取排序值，未定义的角色排在最后
      const sortValueA = ROLE_SORT_MAP[a.roleId] || 999;
      const sortValueB = ROLE_SORT_MAP[b.roleId] || 999;

      return sortValueA - sortValueB;
    });
  }
  const setRoles = (roleList: any[]) => {
    roles.value = roleList
  };
  const setCurrentRole = (roleId: string) => {
    currentRole.value = roleId;
    sessionStorage.setItem('gw-bdus-rid', roleId);
  };
  return {
    roles,
    currentRole,
    setRoles,
    sortRoles,
    setCurrentRole,
  };
};
